/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBriefcaseClock = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M18.646 19.354 17.5 18.207V16h1v1.792l.853.854zM18 14a4 4 0 1 0 0 8 4 4 0 0 0 0-8z" />
        <path d="M7 3v4H2v14h10.803a5.958 5.958 0 0 1-.72-2H4V9h16v3.341c.745.264 1.423.67 2 1.187V7h-5V3zm8 4H9V5h6z" />
      </g>
    </g>
  </Icon>
);
export { SvgBriefcaseClock as BriefcaseClock };
